<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>{{ baseId ? "基地管理" : "基地综合管理" }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ baseId ? "基地生产力统计" : "基地生产力综合总计" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="选择时间区间：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8" v-show="!baseId">
            <el-form-item label="选择统计基地：" prop="farmId">
              <el-select multiple style="width: 100%" size="small" v-model="listParams.farmId" placeholder="请选择基地">
                <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="选择品种：" prop="categoryId">
              <el-select multiple style="width: 100%" size="small" v-model="listParams.categoryId" placeholder="请选择品种">
                <el-option v-for="item in categoryList" :label="item.categoryTitle" :value="item.categoryId" :key="item.categoryId"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>

              <el-button size="small" @click="resetForm('listForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="exportData">-->
          <!--导出-->
          <!--</el-button>-->
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column prop="" align="center" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="categoryTitle" align="center" label="品种"> </el-table-column>

        <el-table-column prop="" align="center" :label="item.farmTitle" v-for="(item, index) in columnList" :key="index">
          <template slot-scope="scope">
            <span>{{ scope.row.farmList[index] }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="total" align="center" label="合计"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        supplyId: "",
        timeInterval: [new Date().getTime() - 31 * 24 * 60 * 60 * 1000, Date.parse(new Date())],
        farmId: [],
        categoryId: [],
      },
      baseNameList: [],
      categoryList: [],
      columnList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      baseId: "",
    };
  },
  mounted() {
    this.loadBaseNameList();
    this.loadCategoryList();
  },
  methods: {
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化品种列表
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/farm/farm-category",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.categoryList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          supplyId: this.listParams.supplyId,
          dateStart: this.listParams.timeInterval[0],
          dateEnd: this.listParams.timeInterval[1],
          farmId: this.listParams.farmId,
          categoryId: this.listParams.categoryId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        }
      );
      if (this.baseId) {
        bodyParams.farmId.push(parseInt(this.baseId));
      }
      this.$http({
        url: global.apiUrl + "/analysis/analysis-farm-index",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.columnList = res.body.data.columnList;
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 导出列表数据
     */
    exportData() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.listParams.supplyId = parseInt(vm.$route.params.supplyId);
      vm.baseId = vm.$route.params.baseId;
      vm.loadTableData();
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
